import { MutableRefObject, useRef, useState } from "react";
import { HexPattern } from "../../../Comps/HexPattern/HexPattern";
import { HxChildMap } from "../../../Comps/HxMap/HxChildMap";
import { Music } from "../../../Util/Music/Music";
import { ChapterConfig } from "../../ChapterConfig";
import { HexPatternIntervals } from "../../Exercises/HexPattern/HexPatternIntervals";
import { HexPatternPositions } from "../../Exercises/HexPattern/HexPatternPositions";
import { HexPatternSequence } from "../../Exercises/HexPattern/HexPatternSequence";
import { LinearKey } from "../../../Comps/LinearKey/LinearKey";
import { HexBuilder } from "../../Exercises/HexBuilder/HexBuilder";
import { OutlineBox } from "../../../Comps/OutlineBox/OutlineBox";
import { ChapterNav, ChapterNavItem } from "../ChapterNav/ChapterNav";
import { ClearHelpers } from "../../Helpers/ClearHelpers/ClearHelpers";
import { Helpers } from "../../Helpers/Helpers";
import { ChapterRoutes } from "../ChapterNav/ChapterRoutes";
import { All } from "../../../Util/Constants/Quantities";
import '../Hex/Hex.scss'
import { DotNav } from "../../../Comps/DotNav/DotNav";
import { NoteCircle } from "../../../Comps/NoteCircle/NoteCircle";
import { NotesSelect } from "../../../Comps/NoteButtons/NotesSelect";
import { useNotePlayer } from "../../../Sound/SoundStore";
import { NotePlayer } from "../../../Sound/NotePlayer";
export function HexPatternChapter(props:ChapterConfig){
    const subPaths:ChapterNavItem[] = [
        {   title:'Lesson',
            path:'lesson',              
            element:<ClearHelpers key={0}>
                        <Lesson/>
                    </ClearHelpers>},
        {   title:'The Sequence Exercise', 
            isExercise:true,
            path:'hexpattern_sequence', 
            element:<ClearHelpers key={1} openHelpers={[Helpers.HexPattern]}>
                        <HexPatternSequence/>
                    </ClearHelpers>},
        {   title:'The Position Exercise', 
            isExercise:true, 
            path:'hexpattern_positions', 
            element:<ClearHelpers key={2} openHelpers={[Helpers.HexPattern]}>
                        <HexPatternPositions/>
                    </ClearHelpers>},
        {   title:'The Interval Exercise', 
            isExercise:true, 
            path:'hexpattern_intervals', 
            element:<ClearHelpers key={3} openHelpers={[Helpers.HexPattern]}>
                        <HexPatternIntervals/>
                    </ClearHelpers>}
    ]
    return  <div>
                <h1>The HexKey Pattern</h1>
                <ChapterNav path={props.path} subPaths={subPaths}/>
                <ChapterRoutes chapterNavs={subPaths}/>
            </div>
}

export function Lesson(){
    const width:number = 900
    const [tonic, setTonic] = useState(Music.G)
    const notePlayer:NotePlayer = useNotePlayer()
    notePlayer.setTonic(tonic)
    const keyNotes:number[] = Music.getKeyScale(tonic)
    const [screenIndex, setScreenIndex] = useState<number>(0)
    const hilitedNotes:MutableRefObject<number[]> = useRef([])
    const selectedNotes:MutableRefObject<number[]> = useRef([])
    const definedNotes:MutableRefObject<number[]> = useRef([])
    const visibleLines:MutableRefObject<number[]> = useRef([])
    const setNoteData = () => {
        switch (screenIndex) {
            case 0:
                hilitedNotes.current = []
                definedNotes.current = []
                selectedNotes.current = []
                visibleLines.current = []
                break;
            case 1:
                hilitedNotes.current = [0]
                definedNotes.current = [0]
                selectedNotes.current = []
                visibleLines.current = []
                notePlayer.playNote(keyNotes[0], true)
                break;
            case 2:
                hilitedNotes.current = [1]
                definedNotes.current = [0,1]
                selectedNotes.current = [0]
                visibleLines.current = []
                notePlayer.playNote(keyNotes[1], true)
                break;
            case 3:
                hilitedNotes.current = [1]
                definedNotes.current = [0,1]
                selectedNotes.current = [0]
                visibleLines.current = [0,1]
                notePlayer.playNotes([keyNotes[0], keyNotes[1]], true, 400)
                break;
            case 4:
                hilitedNotes.current = [2]
                definedNotes.current = [0,1,2]
                selectedNotes.current = [0,1]
                visibleLines.current = [0,1]
                notePlayer.playNote(keyNotes[2], true)
                break;
            case 5:
                hilitedNotes.current = [2]
                definedNotes.current = [0,1,2]
                selectedNotes.current = [0,1]
                visibleLines.current = [0,1,2]
                notePlayer.playNotes([keyNotes[1], keyNotes[2]], true, 400)
                break;
            case 6:
                hilitedNotes.current = [3]
                definedNotes.current = [0,1,2,3]
                selectedNotes.current = [0,1,2]
                visibleLines.current = [0,1,2]
                notePlayer.playNote(keyNotes[3], true)
                break;
            case 7:
                hilitedNotes.current = [3]
                definedNotes.current = [0,1,2,3]
                selectedNotes.current = [0,1,2]
                visibleLines.current = [0,1,2,3]
                notePlayer.playNotes([keyNotes[2], keyNotes[3]], true)
                break;
            case 8:
                hilitedNotes.current = [4]
                definedNotes.current = [0,1,2,3,4]
                selectedNotes.current = [0,1,2,3]
                visibleLines.current = [0,1,2,3]
                notePlayer.playNote(keyNotes[4], true)
                break;
            case 9:
                hilitedNotes.current = [4]
                definedNotes.current = [0,1,2,3,4]
                selectedNotes.current = [0,1,2,3]
                visibleLines.current = [0,1,2,3,4]
                notePlayer.playNotes([keyNotes[3], keyNotes[4]], true)
                break;
            case 10:
                hilitedNotes.current = [5]
                definedNotes.current = [0,1,2,3,4,5]
                selectedNotes.current = [0,1,2,3,4]
                visibleLines.current = [0,1,2,3,4]
                notePlayer.playNote(keyNotes[5], true)
                break;
            case 11:
                hilitedNotes.current = [5]
                definedNotes.current = [0,1,2,3,4,5]
                selectedNotes.current = [0,1,2,3,4,5]
                visibleLines.current = [0,1,2,3,4,5]
                notePlayer.playNotes([keyNotes[4], keyNotes[5]], true)
                break;
            case 12:
                hilitedNotes.current = [6]
                definedNotes.current = [0,1,2,3,4,5,6]
                selectedNotes.current = [0,1,2,3,4,5]
                visibleLines.current = [0,1,2,3,4,5]
                notePlayer.playNote(keyNotes[6], true)
                break;
            case 13:
                hilitedNotes.current = [6]
                definedNotes.current = [0,1,2,3,4,5,6]
                selectedNotes.current = [0,1,2,3,4,5]
                visibleLines.current = [0,1,2,3,4,5,6]
                notePlayer.playNotes([keyNotes[5], keyNotes[6],keyNotes[0]], true)
                break;
            case 14:
                hilitedNotes.current = []
                definedNotes.current = [0,1,2,3,4,5,6]
                selectedNotes.current = [0,1,2,3,4,5,6]
                visibleLines.current = [0,1,2,3,4,5,6]

                notePlayer.playNotes([keyNotes[0],keyNotes[1],keyNotes[2],keyNotes[3],keyNotes[4],keyNotes[5], keyNotes[6],keyNotes[0]], true)
                break;
            default:
                break;
        }
    }
    const onNavClick = (index:number) => {
        setScreenIndex(index)
    }
    const getHilitedNoteTonics = () => {
        const hilitedTonics:number[] = []
        const keyScale:number[] = Music.getKeyScale(tonic)
        definedNotes.current.forEach((noteIndex:number)=>{
            const noteTonic:number = keyScale[noteIndex]
            hilitedTonics.push(noteTonic)
        })
        return hilitedTonics
    }
    setNoteData()

    return(
        
            <div className={'Hex-Pattern Hex Lesson'}>
                <OutlineBox title={'The HexKey Pattern'} width={width}>
                    <NotesSelect tonic={tonic} onChange={setTonic}/>
                    <LinearKey tonic={tonic} hilitedNote={hilitedNotes.current[0]}/>
                    <div style={{display:'flex', width:width, margin:'auto'}}>
                        <div style={{flex:1}}>
                            <HxChildMap height={300} width={300} tonic={tonic} radius={100} 
                                        hilitedNotes={hilitedNotes.current} 
                                        definedNotes={[All]}
                                        selectedNotes={selectedNotes.current}
                                        singleSelect={true}
                            ></HxChildMap>
                        </div>
                        <div style={{flex:1}}>
                            <HexPattern visibleLines={visibleLines.current} 
                                        definedNotes={definedNotes.current} 
                                        hilitedNotes={hilitedNotes.current} 
                                        selectedNotes={selectedNotes.current} 
                                        height={300} width={300} radius={100}
                            ></HexPattern>
                        </div>
                        <div style={{flex:1}}>
                            <NoteCircle rotation={90} radius={100} height={300} width={300} hilitedNotes={getHilitedNoteTonics()}/>
                        </div>
                    </div>
                    <DotNav length={15} selectedIndex={screenIndex} onClick={onNavClick}/>
                </OutlineBox>
            </div>
        
    )
}
export function Exercises(){
    return  <div>
                <HexPatternSequence/>
                <HexPatternPositions/>
                <HexPatternIntervals/>
                <HexBuilder/>
            </div>
}
export function Resources(){
    return <div>HexPattern Resources body</div>
}